export default __webpack_public_path__ + "static/media/imagem_01.dca9ab2c.png";